import type { PortableTextMarkComponent } from '@portabletext/react';
import groq from 'groq';

import { getCoachProfileUrl } from '../../../utils/routing';

export const COACH_PROFILE_LINK_MARK_DEFS_SELECTION = groq`_type == "coachLink" => {
  "coachSlug": coach->slug.current
}`;

interface Props {
  _type: 'coachLink';
  coachSlug: string;
}

const CoachProfileLink: PortableTextMarkComponent<Props> = ({
  value: { coachSlug = '' } = {},
  children,
}) => (
  <a
    className="link underline hover:text-leland-primary"
    href={getCoachProfileUrl(coachSlug)}
    target="_blank"
    rel="noreferrer"
    id="coach_profile_link--view_coach_profile"
  >
    {children}
  </a>
);

export default CoachProfileLink;

export const CoachProfileLinkHtml: PortableTextMarkComponent<Props> = ({
  value: { coachSlug = '' } = {},
  children,
}) => (
  <a
    href={getCoachProfileUrl(coachSlug, undefined, { absolute: true })}
    target="_blank"
    rel="noreferrer"
    id="coach_profile_link--view_coach_profile"
  >
    {children}
  </a>
);
